// imports
import overlayV from "./Glsl/overlay/vertex.glsl"
import overlayF from "./Glsl/overlay/fragment.glsl"

import loadingBarV from "./Glsl/loadingBar/vertex.glsl"
import loadingBarF from "./Glsl/loadingBar/fragment.glsl"


// classes

export default class Shaders
{
    constructor()
    {
        // options
        this.overlayVertex =  overlayV
        this.overlayFragment = overlayF

        this.loadingBarVertex = loadingBarV
        this.loadingBarFragment = loadingBarF

    }
}